import '../styles/main.scss'
import React from 'react'
import { createRoot } from 'react-dom/client'
import Fancybox from './utils/fancybox'
import WordPressPosts from "./components/WordPressPosts";
import VerticalTabs from "./components/VerticalTabs";

/*
    Swiper
    https://swiperjs.com/react#usage
 */
 import Slider from './utils/swiper'

/*
    AOS, kui on natuke teistsuguseid animatsioone vaja
    https://github.com/michalsnik/aos
 */
// import AOS from 'aos';
// import 'aos/dist/aos.css';

/*
    SAL, õrnad animatsioonid mis sobivad peaaegu kõikidele lehtedele
    https://github.com/mciastek/sal
 */
//import sal from 'sal.js';
//import 'sal.js/dist/sal.css'

/*
    Material-UI, komponentide jaoks
    https://mui.com/material-ui/react-accordion/
 */

import Accordion from './utils/accordion'
//import Modal from './utils/modal'
document.addEventListener('DOMContentLoaded', () => {
    Fancybox();
    /*
        sal
     */
    //sal();

    /*
        AOS
     */
    // AOS.init();

    /*
        Swiper
     */
    const slider = document.querySelector('.slider');
    if (slider) {
        createRoot(slider).render(<Slider slides={slides}/>);
    }

    /*
        Load wordPress posts
     */
    const loadPostsContainer = document.getElementById('load-posts');
    if (loadPostsContainer) {
        const postType = loadPostsContainer.dataset.postType || '';
        const categories = loadPostsContainer.dataset.categories
            ? loadPostsContainer.dataset.categories.split(',').map(Number)
            : [];

        createRoot(loadPostsContainer).render(
            <WordPressPosts postType={postType} categories={categories} />
        );
    }

    /*
        MUI accordion
     */
    const accordion = document.querySelector('.accordion');
    if (accordion) {
        createRoot(accordion).render(<Accordion items={repeaterData}/>);
    }

    const tabs = document.querySelector('.repeater-tabs');
    if (tabs) {
        createRoot(tabs).render(<VerticalTabs items={repeaterData}/>);
    }


    // Toggle search field
    var toggleSearch = document.querySelector('.toggle-search');
    var searchField = document.querySelector('.input-container');

    toggleSearch.addEventListener('click', function () {
        searchField.classList.toggle('showit');
    });

    // Hide N/A in filter

    let parentElements = document.getElementsByClassName('wpc-filters-section');
    for (let i = 0; i < parentElements.length; i++) {
        let pElement = parentElements[i].querySelector('p');
        if (pElement && pElement.textContent === 'N/A') {
            parentElements[i].style.display = 'none';
        }
    }
    // responsive navigation

    // Function to check if the screen width is less than 1200px
    function isScreenLessThan1200px() {
        return window.innerWidth < 1200;
    }

// Function to toggle the submenu
    function toggleSubmenu(e) {
        e.preventDefault();
        const submenu = this.nextElementSibling;
        submenu.classList.toggle('open');
    }

// Get the menu items
    const menuItems = document.querySelectorAll('.menu-item-has-children > a');

// Function to add or remove event listeners based on screen size
    function handleScreenSize() {
        if (isScreenLessThan1200px()) {
            menuItems.forEach(function (item) {
                item.addEventListener('click', toggleSubmenu);
            });
        } else {
            menuItems.forEach(function (item) {
                item.removeEventListener('click', toggleSubmenu);
            });
        }
    }

// Call the handleScreenSize function on page load
    handleScreenSize();

// Add a listener for the resize event to handle changes in screen size
    window.addEventListener('resize', handleScreenSize);


    // toggle burger

    var primaryBurger = document.querySelector('.primary-burger');
    var masterNavigation = document.querySelector('.master-navigation');

    primaryBurger.addEventListener('click', function() {
        masterNavigation.classList.toggle('hidden');
        masterNavigation.classList.toggle('block');
        primaryBurger.classList.toggle('nav-is-open');
        document.body.classList.toggle('scroll-hidden');

    });

    // JS modal
    const openModalBtn1 = document.getElementById('openModalBtn1');
    const closeModalBtn1 = document.getElementById('closeModalBtn1');
    const modal1 = document.getElementById('modal1');

    const openModalBtn2 = document.getElementById('openModalBtn2');
    const closeModalBtn2 = document.getElementById('closeModalBtn2');
    const modal2 = document.getElementById('modal2');

    const openModalBtn4 = document.getElementById('openModalBtn4');
    const closeModalBtn4 = document.getElementById('closeModalBtn4');
    const modal4 = document.getElementById('modal4');


    if (openModalBtn1 && modal1) {
        openModalBtn1.addEventListener('click', function () {
            modal1.classList.remove('hidden');
        });
        closeModalBtn1.addEventListener('click', function () {
            modal1.classList.add('hidden');
        });

        window.addEventListener('click', function (event) {
            if (event.target === modal1) {
                modal1.classList.add('hidden');
            }
        });

        /**/
        var seasonalRadios = document.querySelectorAll('input[name="seasonal"]');
        var conditionalContent = document.querySelector('.conditional-content');

        function updateConditionalContentClass() {
            if (seasonalRadios[0].checked) {
                conditionalContent.classList.add('is-conditional');
            } else {
                conditionalContent.classList.remove('is-conditional');
            }
        }

        seasonalRadios.forEach(function(radio) {
            radio.addEventListener('change', updateConditionalContentClass);
        });

        // Check initial value on page load
        updateConditionalContentClass();
    }

    if (openModalBtn2 && modal2) {
        openModalBtn2.addEventListener('click', function () {
            modal2.classList.remove('hidden');
        });

        closeModalBtn2.addEventListener('click', function () {
            modal2.classList.add('hidden');
        });

        window.addEventListener('click', function (event) {
            if (event.target === modal2) {
                modal2.classList.add('hidden');
            }
        });
    }
    if (openModalBtn4 && modal4) {
        openModalBtn4.addEventListener('click', function () {
            modal4.classList.remove('hidden');
        });

        closeModalBtn4.addEventListener('click', function () {
            modal4.classList.add('hidden');
        });

        window.addEventListener('click', function (event) {
            if (event.target === modal4) {
                modal4.classList.add('hidden');
            }
        });
    }


    const closeModalBtn3 = document.getElementById('closeModalBtn3');
    const modal3 = document.getElementById('modal3');
    const checkbox = document.querySelector('input[name="acceptance"]');

// Function to set a cookie
    function setCookie(name, value, days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        const expires = "expires=" + date.toUTCString();
        document.cookie = name + "=" + value + ";" + expires + ";path=/";
    }

// Function to get the value of a cookie by name
    function getCookie(name) {
        const cookieName = name + "=";
        const cookies = document.cookie.split(';');
        for (let i = 0; i < cookies.length; i++) {
            let cookie = cookies[i];
            while (cookie.charAt(0) === ' ') {
                cookie = cookie.substring(1);
            }
            if (cookie.indexOf(cookieName) === 0) {
                return cookie.substring(cookieName.length, cookie.length);
            }
        }
        return null;
    }

    if (modal3 && checkbox) {
        closeModalBtn3.addEventListener('click', function() {
            modal3.classList.add('hidden');
            // Set a cookie when the modal is closed and the checkbox is selected
            if (checkbox.checked) {
                setCookie('modalHidden', 'true', 30); // The cookie will expire in 30 days
            }
        });

        window.addEventListener('click', function(event) {
            if (event.target === modal3) {
                modal3.classList.add('hidden');
                // Set a cookie when the modal is closed and the checkbox is selected
                if (checkbox.checked) {
                    setCookie('modalHidden', 'true', 30);
                }
            }
        });

        // Check for the cookie when the page loads and hide the modal if the condition is met
        window.addEventListener('load', function() {
            if (checkbox.checked || getCookie('modalHidden') === 'true') {
                modal3.classList.add('hidden');
            }
        });
    }


    // Function to check if the word exists in the DOM
    function checkWordInDOM(word) {
        // Get all the text nodes in the DOM
        const walker = document.createTreeWalker(
            document.body,
            NodeFilter.SHOW_TEXT,
            null,
            false
        );

        // Iterate through each text node
        while (walker.nextNode()) {
            const node = walker.currentNode;
            const text = node.nodeValue;

            // Check if the word exists in the text node
            if (text.includes(word)) {
                return true;
            }
        }

        return false;
    }
/*
// Call the function and display an alert
    const word = "jätkupiimasegu";
    if (checkWordInDOM(word)) {
        console.log(`The word "${word}" exists in the DOM.`);
    } else {
        //alert(`The word "${word}" does not exist in the DOM.`);
    }
*/

    // Contact form image upload

    const fileInput = document.getElementById('upload');
    const fileNameDisplay = document.querySelector('.file-name');

    // Check if the elements exist before proceeding
    if (fileInput && fileNameDisplay) {
        fileInput.addEventListener('change', function() {
            const fileName = this.files.length > 0 ? this.files[0].name : 'pole veel valitud';
            fileNameDisplay.textContent = 'Fail: ' + fileName;
        });
    }

});
